"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("./index.scss"));

var _arrowInline = _interopRequireDefault(require("./arrow.inline.svg"));

var ArrowIcon = function ArrowIcon(_ref) {
  var className = _ref.className,
      iconProps = (0, _objectWithoutProperties2["default"])(_ref, ["className"]);
  return _react["default"].createElement(_arrowInline["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(_index["default"].Icon, className)
  }, iconProps));
};

ArrowIcon.propTypes = {
  className: _propTypes["default"].string
};
var _default = ArrowIcon;
exports["default"] = _default;